export enum CollateralQualityTestValue {
    AssetPar = "AssetPar",
    WalYears = "WalYears",
    BondsPercentage = "BondsPercentage",
    WasPercentage = "WasPercentage",
    MoodysWARF = "MoodysWARF",
    MoodysWeightedAverageRecoveryRatePercentage = "MoodysWeightedAverageRecoveryRatePercentage",
    FitchWeightedAverageRatingFactor = "FitchWeightedAverageRatingFactor",
    FitchWeightedAverageRecoveryRatePercentage = "FitchWeightedAverageRecoveryRatePercentage",
    MoodysCorrelationTest = "MoodysCorrelationTest",
    MoodysDiversityScore = "MoodysDiversityScore",
    SnPWeightedAverageRecoveryRatePercentage = "SnPWeightedAverageRecoveryRatePercentage",
    WeightedAverageCoupon = "WeightedAverageCoupon",
    WeightedAverageCouponOfFixedRateAssets = "WeightedAverageCouponOfFixedRateAssets",
    WeightedAverageCouponOfFloatingRateAssets = "WeightedAverageCouponOfFloatingRateAssets",
    PurchasePrice = 'PurchasePrice',
    LiborFloor = 'LiborFloor',
    FirstLienLoans = 'FirstLienLoans',
    SecondLienLoans = 'SecondLienLoans',
    CovLite = 'CovLite',
    MoodysCaaAssets = 'MoodysCaaAssets',
    SPCCCAssets = 'SPCCCAssets',
    ReplinePercentage = 'ReplinePercentage',
    Fixed = 'Fixed',
    Floating = 'Floating',
    CccCaa = 'CccCaa',
    Defaulted = 'Defaulted',
    Ramped = 'Ramped',
    Identified = 'Identified',
    Repline = 'Repline',
}

export const portfolioComposition = {
    title: "Portfolio Composition",
    values: [
        CollateralQualityTestValue.FirstLienLoans,
        CollateralQualityTestValue.SecondLienLoans,
        CollateralQualityTestValue.BondsPercentage,
        CollateralQualityTestValue.Fixed,
        CollateralQualityTestValue.Floating,
        CollateralQualityTestValue.CovLite,
    ],
};

export const creditQualityAndRatings = {
    title: "Credit Quality and Ratings",
    values: [
        CollateralQualityTestValue.CccCaa,
        CollateralQualityTestValue.MoodysCaaAssets,
        CollateralQualityTestValue.SPCCCAssets,
        CollateralQualityTestValue.Defaulted,
        CollateralQualityTestValue.MoodysWARF,
        CollateralQualityTestValue.FitchWeightedAverageRatingFactor,
        CollateralQualityTestValue.MoodysDiversityScore,
        CollateralQualityTestValue.MoodysCorrelationTest,
    ],
};

export const recoveryProfile = {
    title: "Recovery Profile",
    values: [
        CollateralQualityTestValue.MoodysWeightedAverageRecoveryRatePercentage,
        CollateralQualityTestValue.SnPWeightedAverageRecoveryRatePercentage,
        CollateralQualityTestValue.FitchWeightedAverageRecoveryRatePercentage,
    ],
};

export const yieldAndIncome = {
    title: "Yield and Income",
    values: [
        CollateralQualityTestValue.WasPercentage,
        CollateralQualityTestValue.WeightedAverageCoupon,
        CollateralQualityTestValue.WeightedAverageCouponOfFloatingRateAssets,
        CollateralQualityTestValue.WeightedAverageCouponOfFixedRateAssets,
    ],
};

export const structuralMetricsAndPortfolioBuild = {
    title: "Structural Metrics and Portfolio Build",
    values: [
        CollateralQualityTestValue.PurchasePrice,
        CollateralQualityTestValue.LiborFloor,
        CollateralQualityTestValue.WalYears,
        CollateralQualityTestValue.AssetPar,
        CollateralQualityTestValue.Ramped,
        CollateralQualityTestValue.Identified,
        CollateralQualityTestValue.ReplinePercentage,
        CollateralQualityTestValue.Repline,
    ],
};

export const collateralQualityTestGroups = [
    portfolioComposition,
    yieldAndIncome,
    creditQualityAndRatings,
    structuralMetricsAndPortfolioBuild,
    recoveryProfile,
];
